

import { translate } from "react-i18next";
import * as React from "react";
import classNames from "classnames";
import { Menu, DivTooltip, TooltipBody } from "@wg/wows-react-uikit";
import styles from "./BattleSelector.scss";
import { t } from "../../../helpers/localization";

type Item = {
  value: string | number;
  content: string | React.ReactNode;
  isDisabled?: boolean;
};
type BattleType = string | number;

export type IProps = {
  items: Array<Item>;
  selected: string;
  dropdownPosition: string;

  onBattleTypeChange: (arg0: BattleType) => void;
  t: (arg0: string) => void;
};

type IState = {
  isMenuActive: boolean;
  currentDropdownPosition: string;
};

const BATTLE_TYPES = {
  PVP: 'pvp'
};

class BattleSelector extends React.Component<IProps, IState> {

  static defaultProps = {
    dropdownPosition: 'bottom'
  };


  constructor(props) {
    super(props);

    this.state = {
      isMenuActive: false,
      currentDropdownPosition: this.props.dropdownPosition
    };
  }

  appContainer: HTMLElement | null;

  componentDidMount() {
    this.appContainer = document.getElementById('app');
    if (this.appContainer) this.appContainer.addEventListener('scroll', this.onScroll);

  }

  componentWillUnmount() {
    if (this.appContainer) this.appContainer.removeEventListener('scroll', this.onScroll);

  }

  onScroll = (e: any) => {
    const scrollPosition = e.target.scrollTop;
    const dropdownPosition = scrollPosition > 100 ? 'bottom' : this.props.dropdownPosition;

    if (dropdownPosition !== this.state.currentDropdownPosition) {
      this.setState({ currentDropdownPosition: dropdownPosition });
    }
  };

  onItemChange = (battleType: BattleType) => {
    this.setState({
      isMenuActive: false
    });
    if (battleType !== this.props.selected) {
      this.props.onBattleTypeChange(battleType);
    }
  };

  onMenuBlur = () => {
    this.setState({
      isMenuActive: false
    });
  };

  onMenuToggled = isMenuActive => {
    this.setState({
      isMenuActive: isMenuActive
    });
  };

  render() {
    const selected = this.props.selected ? this.props.selected : BATTLE_TYPES.PVP;
    const classNameBattleSelector = classNames(styles.battleSelector, styles[selected]);
    let itemSelected = this.props.items.find(item => item.value === selected);

    if (!itemSelected) return null;

    return <div className={styles.container}>
                <DivTooltip tooltipBody={<TooltipBody withMouseClick>{t('Выбрать тип боя для отображения статистики')}</TooltipBody>}>
                    <Menu items={this.props.items} itemSelected={itemSelected.value} onItemChange={this.onItemChange} onMenuBlur={this.onMenuBlur} onMenuToggled={this.onMenuToggled} dropdownPosition={this.state.currentDropdownPosition}>
                        <div className={classNameBattleSelector}>
                            {itemSelected.content}
                        </div>
                    </Menu>
                </DivTooltip>
            </div>;
  }
}

export default translate()(BattleSelector);